import { Link } from "react-router-dom";
import { ArrowRight, Home, PackageCheck, Plane, Building2, Warehouse } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const audiences = [
  { icon: Home, title: "Property owners", desc: "Document your property's condition for maintenance, warranty follow-up or resale.", href: "/property-snagging-dubai" },
  { icon: PackageCheck, title: "Buyers at handover", desc: "An independent record of visible findings before you accept the property.", href: "/handover-inspection-dubai" },
  { icon: Plane, title: "Overseas owners", desc: "We inspect on your behalf and deliver everything digitally, wherever you are.", href: "/services/overseas-property-inspection-dubai" },
  { icon: Building2, title: "Investors & landlords", desc: "Condition evidence before purchase, during the defect-liability period or between tenancies.", href: "/resale-property-inspection-dubai" },
  { icon: Warehouse, title: "Commercial property clients", desc: "Visual, non-destructive inspections for offices, retail units and agreed commercial spaces.", href: "/commercial-property-inspection-dubai" },
];

export default function WhoWeHelp() {
  return (
    <section className="py-20 lg:py-24 bg-soft border-y border-line" data-testid="who-we-help">
      <div className="wrap">
        <SectionHead eyebrow="Who we help" title="The right report for every kind of client."
          sub="Owners, buyers, investors, landlords and overseas owners — each inspection is scoped to your situation." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {audiences.map((a, i) => (
            <Reveal key={a.title} delay={(i % 5) * 0.04}>
              <Link to={a.href} data-testid={`who-${a.href.split("/").pop()}`}
                className="group block h-full border border-line rounded-[14px] p-6 bg-white hover:border-blue hover:shadow-sm hover:-translate-y-0.5 transition-all">
                <div className="w-11 h-11 rounded-[10px] bg-blue-50 grid place-items-center text-blue mb-4 group-hover:bg-blue group-hover:text-white transition-colors"><a.icon size={21} /></div>
                <h3 className="text-[1.05rem] font-semibold mb-1.5">{a.title}</h3>
                <p className="text-muted text-[0.85rem] leading-relaxed mb-3">{a.desc}</p>
                <span className="text-[0.83rem] font-semibold text-blue inline-flex items-center gap-1.5 group-hover:gap-2.5 transition-all">Learn more <ArrowRight size={14} /></span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
